import type { FaireProductEntity } from "../../entity_types/product";

export const p_67ebfmv2mt: FaireProductEntity = {
  token: "p_67ebfmv2mt",
  type: "product",
  name: "Makinna Poplin Dress",
  brandToken: "b_6l373r5919",
  brandName: "LA RELAXED",
  imageUrl: "https://cdn.faire.com/fastly/2cc39fa9a56d1f08e38e725dda58275e49c17ccc9c09b1ec56466261a3237969.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4d68cf0f005d68a1bd4960e37a9003bacfe61261b5722be81f24681faa2ee352.jpeg",
    "https://cdn.faire.com/fastly/1e03f0185c6f055f2727eff7b72297b546740e63b99c2f1c9653076951e57c85.jpeg",
    "https://cdn.faire.com/fastly/a905784db6755040568d5c582db9b5199a2ad63569d525e4f0b9c30053ba6a6a.jpeg",
    "https://cdn.faire.com/fastly/88069e4135a6cc81d5a3300abeb3c00b821c061af910773903326a284b1d2d01.jpeg",
    "https://cdn.faire.com/fastly/1b3d491546b32f7a01ed0961a13b4626cbd7666fbdbc171f97093d365eb43790.jpeg",
    "https://cdn.faire.com/fastly/15de3c7199d604fbfc67539be5ddf5222b0e3a7d9416d0d266d0e1e5804fd5f9.jpeg",
    "https://cdn.faire.com/fastly/d795e5bdbd0a4bd2304425323d8b4276db7a738e5f8b51401e77eaba62afb1ac.jpeg",
    "https://cdn.faire.com/fastly/7c4d94f139b0033af08affb5159ff6a95f94cf50aa63cd5edbf4c0e3268f8e40.jpeg",
    "https://cdn.faire.com/fastly/984a22b866ede9dd5f920068c3cf8dd787617c7c8ece03b6b27bd9764af80626.jpeg",
    "https://cdn.faire.com/fastly/fecfbec7009a750835f71722119056c345adeff051a26af1ff4efd3d83b374de.jpeg",
    "https://cdn.faire.com/fastly/9beebe675f43662eab50c9b9672fc6af6003908facb7abf8ad2f46c38848c59b.jpeg",
    "https://cdn.faire.com/fastly/0a4ecc4a2c8ac97f9b6aa40f77ff9ec1abbf594899c3669735b2fd5ccaae01c3.jpeg",
    "https://cdn.faire.com/fastly/2ae61806cafccb3d4a5f8c1605c16d0b865ea9f9f160a744d96f18d22cf6ef81.jpeg",
    "https://cdn.faire.com/fastly/83f2db5ca1223961a5f1724005e2ffad327e677c0737b87c4e8654397ae617b8.jpeg",
    "https://cdn.faire.com/fastly/12111cca4cca2313d37dae14ea5bb91f34f6612e73691497515fb2f69ab23061.jpeg",
    "https://cdn.faire.com/fastly/ad445213a1a8f321cd74039705a548c6afb1c6bf90d56e4eccd68ff112f35eec.jpeg"
  ],
  priceDollars: 84,
  description: "An airy carefree dress made of crisp organic poplin and accented with cotton lace trim. Features a relaxed fit with a deep v neckline, embroidered bodice panel and comfortable armholes. Length is 52\".\n\nDetails:\n\n- Organic poplin woven fabric\n\n- Dyed with AZO-free dyes.\n\n- Garment dyed and pre-shrunk.\n\n100% Organic Cotton. \n\n\n\nAlivia is 5'9\" and wears size Small. Brittany is 5'4\" and wears size Small. Makinna is 5'7\" and wearing size Medium.\n",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:50.552Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
